var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssetKuroVtcRunning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_178_1",
    "data-name": "Component 178 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 148.582,
    height: 138.894,
    viewBox: "0 0 148.582 138.894",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1484",
    "data-name": "Path 1484",
    d: "M151.983,121.2V25.613c0-12.489-4.895-18.294-15.651-18.294H19.476C8.72,7.319,3.4,13.124,3.4,25.613V121.2H71.412V134.55H45.444v11.663h64.92V134.55H84.4V121.2Zm-139-95.59c0-4.163,2.907-7.538,6.492-7.538H136.331c3.585,0,6.492,3.375,6.492,7.538v82.913H12.984Z",
    transform: "translate(-3.401 -7.319)",
    fill: "#8cbe7f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_174_6",
    "data-name": "Component 174 \\u2013 6",
    transform: "translate(7.387 8.646)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "videoconference"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1549",
    "data-name": "Path 1549",
    d: "M132.083,105.322H23.887c-4.908,0-8.887-3.623-8.887-8.093V23.681c0-4.469,3.979-8.093,8.887-8.093h108.2c4.908,0,8.887,3.623,8.887,8.093V97.229C140.971,101.7,136.991,105.322,132.083,105.322Z",
    transform: "translate(-11.081 -12.02)",
    fill: "#cef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1550",
    "data-name": "Path 1550",
    d: "M310.156,15.588H256.044v89.734h54.112c4.909,0,8.888-3.623,8.888-8.092V23.681c0-4.469-3.979-8.093-8.888-8.093Z",
    transform: "translate(-189.154 -12.02)",
    fill: "#ff405c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1551",
    "data-name": "Path 1551",
    d: "M15,204.2v36.774c0,4.469,3.979,8.092,8.887,8.092h108.2c4.908,0,8.887-3.623,8.887-8.092V204.2Z",
    transform: "translate(-11.081 -155.768)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1552",
    "data-name": "Path 1552",
    d: "M256.044,204.2V249.07h54.112c4.909,0,8.888-3.623,8.888-8.092V204.2Z",
    transform: "translate(-189.154 -155.768)",
    fill: "#00215a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1554",
    "data-name": "Path 1554",
    d: "M273.341,392.824h0Z",
    transform: "translate(-189.154 -299.521)",
    fill: "#192b80"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_28",
    "data-name": "Ellipse 28",
    cx: 9.047,
    cy: 8.238,
    rx: 9.047,
    ry: 8.238,
    transform: "translate(88.428 59.809)",
    fill: "#ffa64d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1557",
    "data-name": "Path 1557",
    d: "M373.119,252.019v16.476c5,0,9.047-3.688,9.047-8.238S378.115,252.019,373.119,252.019Z",
    transform: "translate(-275.644 -192.21)",
    fill: "#f93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1558",
    "data-name": "Path 1558",
    d: "M336.4,326.637H324.533v0c-5.011.036-9.062,3.744-9.062,8.316v1.867A2.292,2.292,0,0,0,317.863,339h25.283a2.292,2.292,0,0,0,2.392-2.178v-1.867C345.538,330.361,341.448,326.637,336.4,326.637Z",
    transform: "translate(-233.056 -249.078)",
    fill: "#7affe4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1559",
    "data-name": "Path 1559",
    d: "M378.991,326.637h-5.873V339h12.615a2.292,2.292,0,0,0,2.392-2.178v-1.867C388.125,330.361,384.036,326.637,378.991,326.637Z",
    transform: "translate(-275.644 -249.078)",
    fill: "#00ecce"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    cx: 9.047,
    cy: 8.238,
    rx: 9.047,
    ry: 8.238,
    transform: "translate(27.447 59.809)",
    fill: "#fc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1560",
    "data-name": "Path 1560",
    d: "M139.695,252.019v16.476c5,0,9.047-3.688,9.047-8.238S144.692,252.019,139.695,252.019Z",
    transform: "translate(-103.201 -192.21)",
    fill: "#ffb366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1561",
    "data-name": "Path 1561",
    d: "M102.98,326.637H91.109v0c-5.011.036-9.061,3.744-9.061,8.316v1.867A2.292,2.292,0,0,0,84.439,339h25.283a2.292,2.292,0,0,0,2.392-2.178v-1.867C112.114,330.361,108.024,326.637,102.98,326.637Z",
    transform: "translate(-60.613 -249.078)",
    fill: "#ff9100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1562",
    "data-name": "Path 1562",
    d: "M145.567,326.637h-5.873V339h12.615a2.292,2.292,0,0,0,2.392-2.178v-1.867C154.7,330.361,150.612,326.637,145.567,326.637Z",
    transform: "translate(-103.2 -249.078)",
    fill: "#ff641a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 9.047,
    cy: 8.238,
    rx: 9.047,
    ry: 8.238,
    transform: "translate(88.428 18.319)",
    fill: "#ffa64d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1563",
    "data-name": "Path 1563",
    d: "M373.119,77.6V94.075c5,0,9.047-3.688,9.047-8.238S378.115,77.6,373.119,77.6Z",
    transform: "translate(-275.644 -59.28)",
    fill: "#f93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1564",
    "data-name": "Path 1564",
    d: "M336.4,152.217H324.533v0c-5.011.036-9.062,3.744-9.062,8.316V162.4a2.292,2.292,0,0,0,2.392,2.178h25.283a2.292,2.292,0,0,0,2.392-2.178v-1.867C345.538,155.941,341.448,152.217,336.4,152.217Z",
    transform: "translate(-233.056 -116.148)",
    fill: "#ffda2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1565",
    "data-name": "Path 1565",
    d: "M378.991,152.217h-5.873V164.58h12.615a2.292,2.292,0,0,0,2.392-2.178v-1.867C388.125,155.941,384.036,152.217,378.991,152.217Z",
    transform: "translate(-275.644 -116.148)",
    fill: "#fdbf00"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    cx: 9.047,
    cy: 8.238,
    rx: 9.047,
    ry: 8.238,
    transform: "translate(27.447 18.319)",
    fill: "#fc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1566",
    "data-name": "Path 1566",
    d: "M139.695,77.6V94.075c5,0,9.047-3.688,9.047-8.238S144.692,77.6,139.695,77.6Z",
    transform: "translate(-103.201 -59.28)",
    fill: "#ffb366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1567",
    "data-name": "Path 1567",
    d: "M102.98,152.217H91.109v0c-5.011.036-9.061,3.744-9.061,8.316V162.4a2.292,2.292,0,0,0,2.392,2.178h25.283a2.292,2.292,0,0,0,2.392-2.178v-1.867C112.114,155.941,108.024,152.217,102.98,152.217Z",
    transform: "translate(-60.613 -116.148)",
    fill: "#ff405c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1568",
    "data-name": "Path 1568",
    d: "M145.567,152.217h-5.873V164.58h12.615A2.292,2.292,0,0,0,154.7,162.4v-1.867C154.7,155.941,150.612,152.217,145.567,152.217Z",
    transform: "translate(-103.2 -116.148)",
    fill: "#c1126b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1569",
    "data-name": "Path 1569",
    d: "M122.037,97.458H11.771C5.27,97.458,0,92.659,0,86.74V11.305C0,5.386,5.27.588,11.771.588H122.038c6.5,0,11.77,4.8,11.77,10.717V86.74c0,5.919-5.27,10.717-11.771,10.717ZM11.771,7.724a3.77,3.77,0,0,0-3.933,3.581V86.74a3.77,3.77,0,0,0,3.933,3.581H122.037a3.77,3.77,0,0,0,3.933-3.581V11.305a3.77,3.77,0,0,0-3.933-3.581H11.771Z",
    transform: "translate(0 -0.588)",
    fill: "#0089ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1570",
    "data-name": "Path 1570",
    d: "M312.179.588H256.044V7.724h56.135a2.824,2.824,0,0,1,2.946,2.683V86.516a4.006,4.006,0,0,1-4.18,3.806h-54.9v7.136h56.135c5.956,0,10.783-4.4,10.783-9.819V10.407c0-5.423-4.828-9.819-10.783-9.819Z",
    transform: "translate(-189.154 -0.588)",
    fill: "#295fcc"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetKuroVtcRunning);
export default __webpack_public_path__ + "static/media/Asset-KuroVTCRunning.89e2212964c313cae115def14f628742.svg";
export { ForwardRef as ReactComponent };